<template>
    <div class="alignwide">
        <div class="logo-marquee" :class="enoughToAnimate ? '' : 'logo-marquee--no-anim'">
            <TransitionGroup name="logo">
                <div class="logo-marquee__item" v-for="logo in visibleLogos" :key="logo.id">
                    <a v-if="includeLinks" :href="'/organization/' + logo.slug" class="inner-padding">
                        <img :src="logo.logo_image" :alt="logo.organization" :style="imageScale(logo.logo_width_percent)" />
                    </a>
                    <div v-else class="inner-padding">
                        <img :src="logo.logo_image" :alt="logo.organization" :style="imageScale(logo.logo_width_percent)" />
                    </div>
                </div>
            </TransitionGroup>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, computed } from "vue";

const props = defineProps({
    logos: Array,
    fadeDelay: { type: Number, default: 5000 },
    includeLinks: {type: Boolean, default: false },
});

const validLogos = computed(() => {
    return props.logos.filter((logo) => logo.logo_image !== null);
});

const sortedLogos = computed(() => {
    return validLogos.value.sort((a, b) => {
        return a.organization.localeCompare(b.organization);
    });
});

const smallBreakpoint = 560;
const visibleLogos = ref([]);
const currentIndex = ref(0);
const visibleCount = ref(window.innerWidth < smallBreakpoint ? 3 : 5);

const updateVisibleLogos = () => {
    // Stop updating if there are not enough logos to animate
    if (!enoughToAnimate.value) {
        return;
    }
    // Remove all visible logos
    visibleLogos.value = [];

    // Update the current index and add the next logos from the list
    currentIndex.value = (currentIndex.value + visibleCount.value) % sortedLogos.value.length;

    for (let i = 0; i < visibleCount.value; i++) {
        const nextIndex = (currentIndex.value + i) % sortedLogos.value.length;
        visibleLogos.value.push(sortedLogos.value[nextIndex]);
    }
};

const handleResize = () => {
    const newVisibleCount = window.innerWidth < smallBreakpoint ? 3 : 5;
    if (visibleCount.value !== newVisibleCount) {
        visibleCount.value = newVisibleCount;
        updateVisibleLogos();
    }
};

const imageScale = (percent) => {
    let style = "transform: scale(" + percent / 100 + ")";
    return style;
};

console.log({
    'visibleCount.value' : visibleCount.value,
    'sortedLogos.value' : sortedLogos.value
});
const enoughToAnimate = computed(() => {
    return visibleCount.value <= sortedLogos.value.length 
})


onMounted(() => {
    // Determine the starting index based on the length of sortedLogos
    const randomIndex = sortedLogos.value.length <= visibleCount.value ? 0 : Math.floor(Math.random() * sortedLogos.value.length);

    // Initialize visible logos
    visibleLogos.value = sortedLogos.value.slice(randomIndex, randomIndex + visibleCount.value);

    // If the total number of logos is less than the desired visible count, no need to wrap around
    if (sortedLogos.value.length > visibleCount.value) {
        // If the slice didn't return enough logos, wrap around to the beginning of the array
        while (visibleLogos.value.length < visibleCount.value) {
            visibleLogos.value.push(
                sortedLogos.value[
                    (visibleLogos.value.length + randomIndex) % sortedLogos.value.length
                ]
            );
        }
    }

    // Update the current index to the last visible logo's index
    currentIndex.value = (randomIndex + visibleCount.value - 1) % sortedLogos.value.length;

    // Set up a timer to update visible logos every 5 seconds
    const intervalId = setInterval(updateVisibleLogos, props.fadeDelay);

    // Add event listener for window resize
    window.addEventListener('resize', handleResize);

    // Clean up the timer and event listener when the component is unmounted
    onUnmounted(() => {
        clearInterval(intervalId);
        window.removeEventListener('resize', handleResize);
    });
});
</script>
